<template>
  <div :id="id" :style="{width: width, height: height}" />
</template>
<script>
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/radar'
import 'echarts/lib/chart/custom'
import 'echarts/lib/chart/gauge'

import 'echarts/lib/component/dataZoom'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/markLine'
import 'echarts/lib/component/markPoint'
import 'echarts/lib/component/markArea'
import 'echarts/lib/component/visualMap'
import 'echarts/lib/component/legendScroll'
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '360px'
    },
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      myChart: null
    }
  },
  watch: {},
  mounted() {
    this.initChart()
    this.myChart.on('legendselectchanged', (legends) => {
      this.$emit('legendselectchanged', legends)
    })
  },
  methods: {
    initChart() {
      this.myChart = echarts.init(document.getElementById(this.id), null, {
        devicePixelRatio: 3
      })
      this.update()
    },
    update() {
      this.myChart.setOption(this.options)
      console.info(656565)
      this.myChart.resize()
    },
    setOption(options) {
      this.myChart.setOption(options, true)
      this.myChart.resize()
    }
  }
}
</script>
